import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-booth-wise-agent-details',
  templateUrl: './booth-wise-agent-details.component.html',
  styleUrls: ['./booth-wise-agent-details.component.scss']
})
export class BoothWiseAgentDetailsComponent implements OnInit {
  title: any;
  input_type_list = ['Business', 'Business Type'];
  selected_input_type: any = null;
  business_code: number = null;
  business_type_list: any;
  selected_business_types: any = null;
  zone_list: any = null;
  selected_zones: any = null;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  data_dict: any;

  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.getBoothTypes().subscribe((business_type_list: []) => {
      console.log(business_type_list);
      this.business_type_list = business_type_list;
    }, (error) => {
      console.log(error);
    });

    this.httpService.getZones().subscribe((zones: []) => {
      console.log(zones);
      this.zone_list = zones;
    }, (error) => {
      console.log(error);
    });
  }

  getClicked() {
    this.document_file = null;
    if(this.selected_input_type == 'Business'){
      this.data_dict = {
        'input_type': this.selected_input_type,
        'business_code': this.business_code
      };
    }
    else{
      this.data_dict = {
        'input_type': this.selected_input_type,
        'selected_business_type': this.selected_business_types,
        'selected_zone': this.selected_zones
      };
    }
    console.log(this.data_dict);
    this.is_document_available = false;
    this.httpService.serveBoothWiseAgentDetails(this.data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

}
